import React, { useEffect, useState } from 'react'
import bwipjs from 'bwip-js'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode as BarcodeType } from 'src/api/models'

interface BarcodeProps {
  barcode: BarcodeType
  width?: number
  height?: number
  scale?: number
  showRawBarcode?: boolean
}

const useStyles = makeStyles(() => ({
  span: {
    textAlign: 'center',
  },
}))

const Barcode = (props: BarcodeProps) => {
  const { barcode, width, height, scale = 1, showRawBarcode = false } = props
  const classes = useStyles()
  const [svg, setSVG] = useState<string | null>(null)
  useEffect(() => {
    const base: any = {}
    if (width) {
      base.width = width
    }
    if (height) {
      base.height = height
    }
    try {
      setSVG(
        bwipjs.toSVG({
          bcid: barcode.type, // Barcode type
          text: barcode.barcode, // Text to encode
          scale,
          includetext: false, // Show human-readable text
          textxalign: 'center', // Always good to set this
          ...base,
        })
      )
    } catch (e) {
      console.error(e)
      setSVG(
        bwipjs.toSVG({
          bcid: 'datamatrix', // Barcode type
          text: barcode.barcode, // Text to encode
          scale,
          includetext: false, // Show human-readable text
          textxalign: 'center', // Always good to set this
          ...base,
        })
      )
    }
  }, [barcode.barcode, barcode.type, scale, width, height])
  return (
    <Box>
      {svg && <div dangerouslySetInnerHTML={{ __html: svg }} />}
      {showRawBarcode && <Typography className={classes.span}>{barcode.barcode}</Typography>}
    </Box>
  )
}

export default Barcode
